
  (function () {
    var BRAND_TRACKING_DOMAIN      = 'https://www.bozpr1bx4dz.com';
    var DEPT_MEDIA_TRACKING_DOMAIN = 'https://www.dhgdf7trk.com';
    var APEX = 'wellmedr.com';
    var COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

    function setApexCookie(name, value) {
      if (value === undefined || value === null || value === '') return;
      document.cookie =
        name + '=' + encodeURIComponent(value) +
        '; domain=.' + APEX +
        '; path=/' +
        '; max-age=' + COOKIE_MAX_AGE +
        '; secure; samesite=lax';
    }

    function deleteApexCookie(name) {
      document.cookie =
        name + '=; domain=.' + APEX + '; path=/; max-age=0; secure; samesite=lax';
    }

    function whenEFReady(cb) {
      var start = Date.now();
      (function poll() {
        if (window.EF) return cb(window.EF);
        if (Date.now() - start > 5000) return;
        setTimeout(poll, 50);
      })();
    }

    // Fires OUR brand click — the one that mints ef_tid and drives both
    // attribution and the server-side conversion postback. sub5Override lets
    // the caller bridge Department Media's click tid into sub5 (this is what
    // DM's Everflow instance matches conversions on; do NOT remove it).
    function fireBrandClick(EF, sub5Override) {
      var offerId      = parseInt(EF.urlParameter('oid'), 10);
      var affiliateId  = parseInt(EF.urlParameter('affid'), 10);
      var sub1 = EF.urlParameter('sub1') || undefined;
      var sub2 = EF.urlParameter('sub2') || undefined;
      var sub3 = EF.urlParameter('sub3') || undefined;
      var sub4 = EF.urlParameter('sub4') || undefined;
      // sub5 = DM click tid, bridged in by the caller (sub5Override) on a DM
      // visit, or an inbound ?sub5= otherwise. Do NOT fall back to the
      // ef_dm_tid cookie here: on the happy path sub5Override already wins, and
      // on a later organic/non-DM visit a stale ef_dm_tid cookie would stamp a
      // previous affiliate's tid onto this click (false DM attribution). The
      // non-DM branch below deletes that cookie for the same reason.
      var sub5 = sub5Override || EF.urlParameter('sub5') || undefined;
      var uid         = EF.urlParameter('uid') || undefined;
      var sourceId    = EF.urlParameter('source_id') || EF.urlParameter('source') || undefined;
      var gclid       = EF.urlParameter('gclid')  || undefined;
      var fbclid      = EF.urlParameter('fbclid') || undefined;
      var ttclid      = EF.urlParameter('ttclid') || undefined;
      var couponCode  = EF.urlParameter('coupon') || EF.urlParameter('coupon_code') || undefined;
      var existingTid = EF.urlParameter('_ef_transaction_id') || EF.urlParameter('ef_tid') || undefined;

      var params = { tracking_domain: BRAND_TRACKING_DOMAIN };
      if (isFinite(offerId))     params.offer_id     = offerId;
      if (isFinite(affiliateId)) params.affiliate_id = affiliateId;
      if (sub1) params.sub1 = sub1;
      if (sub2) params.sub2 = sub2;
      if (sub3) params.sub3 = sub3;
      if (sub4) params.sub4 = sub4;
      if (sub5) params.sub5 = sub5;
      if (uid)        params.uid        = uid;
      if (sourceId)   params.source_id  = sourceId;
      if (gclid)      params.gclid      = gclid;
      if (fbclid)     params.fbclid     = fbclid;
      if (ttclid)     params.ttclid     = ttclid;
      if (couponCode) params.coupon_code = couponCode;
      if (existingTid) params.transaction_id = existingTid;

      Promise.resolve(EF.click(params)).then(function (tid) {
        if (!tid) return;
        try {
          localStorage.setItem('ef_tid', tid);
          if (isFinite(offerId))     localStorage.setItem('ef_offer_id', String(offerId));
          if (isFinite(affiliateId)) localStorage.setItem('ef_affiliate_id', String(affiliateId));
        } catch (e) {}
        setApexCookie('ef_tid', tid);
        if (isFinite(offerId))     setApexCookie('ef_offer_id', offerId);
        if (isFinite(affiliateId)) setApexCookie('ef_affiliate_id', affiliateId);
        setApexCookie('ef_sub1', sub1);
        setApexCookie('ef_sub2', sub2);
        setApexCookie('ef_sub3', sub3);
        setApexCookie('ef_sub4', sub4);
        setApexCookie('ef_sub5', sub5);
        setApexCookie('ef_source_id', sourceId);
        setApexCookie('ef_gclid', gclid);
        setApexCookie('ef_fbclid', fbclid);
        setApexCookie('ef_ttclid', ttclid);
        setApexCookie('ef_coupon_code', couponCode);
      })['catch'](function () {
        // The SDK (v1.5.0) resolves '' on error rather than rejecting, so this
        // is belt-and-suspenders against a future SDK build that rejects.
      });
    }

    whenEFReady(function (EF) {
      // Configure tld BEFORE any clicks so the SDK's internal cookies
      // (ef_tid_c_a_<aid>, etc.) persist on .wellmedr.com and are readable
      // from intake.wellmedr.com.
      EF.configure({ tld: APEX });

      // Accept BOTH spellings. Live DM/affiliate links use 'affid2'; the
      // older code only checked 'aff_id2', which silently skipped the DM branch.
      var dmAffId    = EF.urlParameter('aff_id2') || EF.urlParameter('affid2');
      var dmAffIdNum = parseInt(dmAffId, 10);
      var hasDM      = dmAffId && isFinite(dmAffIdNum);

      // The brand click mints ef_tid and MUST always fire. But DM's Everflow
      // instance matches conversions back to their click via {sub5}, so the
      // brand click has to carry DM's transaction_id in sub5 — Everflow then
      // inherits it onto the conversion. So: fire the DM click FIRST to learn
      // its tid, then fire the brand click with sub5 = dmTid.
      //
      // TIMING — this is the bug that survived ~10 reviews: EF.click() ALWAYS
      // resolves (32-char tid, or '' on failure) and never hangs, so we wait for
      // the DM click and bridge dmTid into the brand click's sub5. The previous
      // version fired the brand click after an 800ms guard; the cross-domain DM
      // click routinely resolves AFTER 800ms live, so the guard fired the brand
      // click first WITHOUT sub5 and the late dmTid was a no-op (brandFired was
      // already true). Looked correct on fast localhost, dropped sub5 in
      // production. The long-stop below is NOT a normal-path timer — it only
      // covers a pathological non-resolving SDK, so it's set far above real DM
      // latency and must never preempt a healthy DM click. Do NOT lower it back
      // toward typical click latency, and do NOT remove the sub5 bridge: both
      // failures are silent (everything else keeps working) and easy to miss.
      var BRAND_CLICK_MAX_WAIT_MS = 3000;
      var brandFired = false;
      function fireBrandOnce(sub5Override) {
        if (brandFired) return;
        brandFired = true;
        fireBrandClick(EF, sub5Override);
      }

      if (!hasDM) {
        // No DM traffic on THIS visit. Clear any DM tid left by an earlier DM
        // visit in this browser so a stale value can't be stamped as sub5 onto
        // this (non-DM) brand click — on the server side or on the Next-app
        // re-fire, both of which read these cookies. This is last-touch
        // consistency: the brand attribution just moved to this non-DM click,
        // so its DM sub5 must move with it (to none).
        deleteApexCookie('ef_dm_tid');
        deleteApexCookie('ef_sub5');
        try { localStorage.removeItem('ef_dm_tid'); } catch (e) {}
        fireBrandOnce();
        return;
      }

      var dmOfferId = parseInt(EF.urlParameter('oid2'), 10);
      // Safety net: brand click fires no later than this even if DM hangs.
      var dmGuard = setTimeout(function () { fireBrandOnce(); }, BRAND_CLICK_MAX_WAIT_MS);

      Promise.resolve(EF.click({
        tracking_domain: DEPT_MEDIA_TRACKING_DOMAIN,
        offer_id:     isFinite(dmOfferId) ? dmOfferId : undefined,
        affiliate_id: dmAffIdNum,
        sub1: EF.urlParameter('sub1') || undefined,
        sub2: EF.urlParameter('sub2') || undefined,
        sub3: EF.urlParameter('sub3') || undefined,
        sub4: EF.urlParameter('sub4') || undefined,
        sub5: EF.urlParameter('sub5') || undefined
      })).then(function (dmTid) {
        clearTimeout(dmGuard);
        if (dmTid) {
          // Persist DM's tid on the apex domain so it survives the hop to the
          // Next app. Its PRIMARY use is the Next-app brand-click re-fire
          // (lib/everflow.ts reads ef_dm_tid as sub5 when it mints a fresh
          // click on intake/checkout — that fresh click is what the conversion
          // attributes to). It is ALSO sent as sub5 on the server-side webhook
          // postback, though that import endpoint may ignore body sub5 — treat
          // that as unverified, not the load-bearing path.
          setApexCookie('ef_dm_tid', dmTid);
          try { localStorage.setItem('ef_dm_tid', dmTid); } catch (e) {}
        }
        // Bridge DM's tid into the brand click's sub5. fireBrandClick prefers
        // sub5Override over the inbound ?sub5= param. If the long-stop already
        // fired the brand click (dmTid late), this is a no-op for the Shopify
        // click, but the ef_dm_tid cookie above still carries sub5 forward via
        // the Next-app re-fire.
        fireBrandOnce(dmTid || undefined);
      })['catch'](function () {
        clearTimeout(dmGuard);
        fireBrandOnce();
      });
    });
  })();
